<template>
    <div>
        <notification-modal v-model:is-open="showReportModal" v-model:is-error-modal="reportModalError">
            <template #title-content>
                {{ modalTitle }}
            </template>

            {{ modalMessage }}
        </notification-modal>
        <base-report>
            <h3 class="text-left text-lg font-semibold">Calibration Report</h3>
            <template #left-column>
                <div class="mb-4 lg:mb-12">
                    <p>
                        The Calibration Report will be emailed to Admin users in PDF format with information on your
                        Sonicu sensors. This report will include:
                    </p>

                    <ul     class="list-disc ml-8">
                        <li>Any sensors that are within 60 days of expiration</li>
                        <li>Any sensors that are expired</li>
                    </ul>

                    <p>
                        Due to the urgency of sensors nearing calibration expiration and increasing regulatory
                        compliance, this report will be automatically emailed to Admin users at the end of each month.
                    </p>

                    <p>
                        This feature can be disabled by an Admin user by contacting Support via the top-right dropdown menu.
                    </p>
                </div>

<!--                <div class="grid grid-cols-1 lg:grid-cols-2 my-2 text-center">-->
<!--                    &lt;!&ndash; Select a zone / Select an area. &ndash;&gt;-->
<!--                    <p>Select a Zone  / Area</p>-->
<!--                </div>-->

                <div class="flex justify-center">
                    <button v-if="isRunning"
                            class="col-span-2 w-full lg:w-2/3 my-4 relative inline-flex items-center justify-center
                            px-4 py-2 border border-transparent text-sm bg-blue-600 text-white font-medium py-2 px-4
                            rounded opacity-50 cursor-not-allowed">
                        <span class="lnr icon-loading animate-spin mr-3"></span>
                        Running Report, Please Wait
                    </button>
                    <button v-else
                            class="col-span-2 w-full lg:w-2/3 my-4 relative inline-flex items-center justify-center px-4 py-2 border
                            border-transparent text-sm leading-5 font-medium rounded-md text-white bg-blue-600
                            hover:bg-blue-500 focus:outline-none focus:ring-blue-200 focus:border-blue-700
                            active:bg-blue-700"
                            @click="runReport">
                        Run Report
                    </button>
                </div>
            </template>

            <template #right-column>
                <!-- Select Users to send report to at the end of each month. -->
                <div    v-if="permissions.can('manage_calibration_report')"
                        class="grid grid-cols-1 lg:grid-cols-2 my-2 text-center">
                    <span>Users to Send to Automatically</span>
                    <select2
                        :multiple="true"
                        :options="allUsers"
                        v-model:value="selectedUsers"
                    ></select2>
                    <button-blue-secondary      @click="includeSiteAdmins"
                                                class="my-2 lg:col-start-2">
                        <div    v-if="! isGettingAdmins">
                            Include any site Admins.
                        </div>
                        <div    v-else>
                            <span class="lnr icon-loading animate-spin mr-3"></span>
                            Getting list of admins, please wait.
                        </div>
                    </button-blue-secondary>
                </div>

                <div    v-if="showScheduledSendDisabledLoaded && ! showScheduledSendDisabled"
                        class="flex justify-center items-center">
                    <div    class="w-1/2">
                        <banner>
                            <template   #title>Scheduled sending of the Calibration Report is not yet Available.</template>
                            <template   #content>
                                We’re excited to bring this feature to our customers soon, but we want to make sure we
                                get a chance to communicate this great new feature to everyone!
                            </template>
                        </banner>
                    </div>
                </div>

                <div class="flex justify-center">
                    <button v-if="isSaving"
                            class="inline-flex justify-center items-center w-1/2 ml-2 px-4 py-2 border-2 border-blue-200 text-md leading-5 font-sm
                            font-sans rounded-md text-blue-700 bg-white rounded opacity-50 cursor-not-allowed">
                        <span class="lnr icon-loading animate-spin mr-3"></span>
                        Saving Settings, Please Wait
                    </button>
                    <button v-else-if="permissions.can('manage_calibration_report')"
                            class="inline-flex justify-center items-center w-1/2 ml-2 px-4 py-2 border-2 border-blue-200 text-md leading-5 font-sm
                            font-sans rounded-md text-blue-700 bg-white hover:bg-blue-600 hover:text-white
                            focus:outline-none focus:ring-blue-200 focus:border-blue-400 active:bg-blue-600"
                            @click="saveSettings">
                        Save Settings
                    </button>
                </div>
            </template>
        </base-report>
    </div>
</template>

<script>
import {SonicuCoreMixin} from "@/mixins/SonicuCoreMixin";
import BaseReport from "./BaseReport"
import Select2 from "@/components/elements/select2"
import Toggle from "@/components/elements/toggle"
import Banner from "@/components/Banners/Banner"
import DateTimePicker from "@/components/Reports/DateTimePicker";

import axios from "axios";
import _ from 'lodash'
import NotificationModal from "@/components/elements/NotificationModal";
import ButtonBlueSecondary from "@/components/elements/buttons/ButtonBlueSecondary";

export default {
    name: "CalibrationReport",
    mixins: [SonicuCoreMixin],
    components: {ButtonBlueSecondary, NotificationModal, DateTimePicker, BaseReport, Select2, Toggle, Banner},
    props: {
        reportQueued: {
            type: String,
            default: null,
        },
        allUsers: {
            type: [Object, Array],
        },
        subscribedUsers: {
            type: [Array],
        },
    },
    data() {
        return {
            isSaving: false,
            isRunning: false,
            isGettingAdmins: false,

            selectedUsers: this.subscribedUsers,

            showReportModal: false,
            reportModalError: false,
            modalMessage: '',
            modalTitle: '',
            isErrorModal: false,

            showScheduledSendDisabled: false,
            showScheduledSendDisabledLoaded: false,
        }
    },
    created() {
    },
    mounted() {
    },
    methods: {
        saveSettings() {
            this.isSaving = true
            let users = []
            Object.keys(this.selectedUsers).forEach(key => {
                users.push(this.selectedUsers[key].toString())
            })
            let formData = {
                subscribed_users: users,
            }
            axios.post(this.company.buildCompanyRoute('reports/calibration-report/update'), formData)
                .then(response => {
                    this.modalMessage = 'Successfully saved report settings.'
                    this.modalTitle = 'Report Saved'
                    this.reportModalError = false
                    this.showReportModal = true
                })
                .catch(error => {
                    this.modalMessage = 'Error saving report settings.'
                    this.modalTitle = 'Error Saving'
                    this.reportModalError = true
                    this.showReportModal = true
                })
                .finally(() => {
                    this.isSaving = false
                })
        },
        runReport() {
            this.isRunning = true
            let formData = {
            }
            axios.post(this.company.buildCompanyRoute('reports/calibration-report'), formData)
                .then(response => {
                    this.modalTitle = 'Report Queued'
                    this.modalMessage = 'You will receive an email when the report is prepared.'
                    this.reportModalError = false
                    this.showReportModal = true
                })
                .catch(error => {
                    this.modalTitle = 'Report Error'
                    this.modalMessage = 'Error running report, please try again later.'
                    this.reportModalError = true
                    this.showReportModal = true
                })
                .finally(() => {
                    this.isRunning = false
                })
        },
        includeSiteAdmins() {
            if (this.isGettingAdmins) {
                // If we are getting the admins already, bail out early.
                return
            }
            this.isGettingAdmins = true

            // Query the site what the admins are.
            let formData = {
                include_all_admins: true,
            }
            axios.post(this.company.buildCompanyRoute('reports/calibration-report/update'), formData)
                .then(response => {
                    let combinedUsers = _.union(this.selectedUsers, response.data.adminIds)
                    combinedUsers = _.uniq(combinedUsers)
                    this.selectedUsers = _.clone(combinedUsers)
                })
                .catch(error => {
                })
                .finally(() => {
                    this.isGettingAdmins = false
                })
        },
    },
    watch: {
    },
    computed: {
    },
}
</script>

<style scoped>

</style>
